module.exports = __webpack_public_path__ + "img/6_98.0b948289.png";